// extracted by mini-css-extract-plugin
export default {"tfd-toast":"kFGAW2","tfdToast":"kFGAW2","container":"je2jkL"};